import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=171203d8&scoped=true&"
import script from "./GroupPage.vue?vue&type=script&lang=ts&"
export * from "./GroupPage.vue?vue&type=script&lang=ts&"
import style0 from "./GroupPage.vue?vue&type=style&index=0&id=171203d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171203d8",
  null
  
)

export default component.exports